<p>
  email-notifactions-templates works!
</p>
